/* ============================================================
   商品カルーセル共通スクリプト
   - .pc-viewport[data-product-carousel] のページ送り＋インジケーター
   - coordinates 内部の画像/商品ミニスライダー [data-coordinate-slider]
   product-recommendations の非同期差し替えにも MutationObserver で追従
   ============================================================ */
(function () {
  'use strict';

  /* ----- ページネーション付きカルーセル ----- */
  function initCarousel(viewport) {
    if (viewport.dataset.pcInit) return;
    viewport.dataset.pcInit = '1';

    var root = viewport.closest('.pc-section') || viewport.parentNode;
    var pagination = root.querySelector('[data-pc-pagination]');
    if (!pagination) return;

    var prev = pagination.querySelector('[data-pc-prev]');
    var next = pagination.querySelector('[data-pc-next]');
    var currentEl = pagination.querySelector('[data-pc-current]');
    var totalEl = pagination.querySelector('[data-pc-total]');

    function update() {
      var pageWidth = viewport.clientWidth;
      if (!pageWidth) return;
      var pages = Math.max(1, Math.ceil((viewport.scrollWidth - 1) / pageWidth));
      if (pages <= 1) {
        pagination.hidden = true;
        return;
      }
      pagination.hidden = false;
      var current = Math.min(pages, Math.round(viewport.scrollLeft / pageWidth) + 1);
      currentEl.textContent = current;
      totalEl.textContent = pages;
      prev.classList.toggle('is-disabled', current <= 1);
      next.classList.toggle('is-disabled', current >= pages);
    }

    prev.addEventListener('click', function () {
      viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
    });
    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ----- カード内部のミニスライダー（画像・商品） ----- */
  function initSlider(slider) {
    if (slider.dataset.csInit) return;
    slider.dataset.csInit = '1';

    var track = slider.querySelector('[data-slider-track]');
    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (!track || !prev || !next) return;

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.classList.toggle('is-disabled', track.scrollLeft <= 0);
      next.classList.toggle('is-disabled', track.scrollLeft >= maxScroll);
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-product-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-coordinate-slider]').forEach(initSlider);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  // product-recommendations 等、後から差し込まれるカルーセルに追従
  if (window.MutationObserver && document.body) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-product-carousel]')) initCarousel(node);
          if (node.matches && node.matches('[data-coordinate-slider]')) initSlider(node);
          if (node.querySelectorAll) initAll(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // テーマエディタでのセクション再読込
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
